var _path, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVendor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.499 14.318L31.7706 8.7882C31.882 8.7418 31.882 8.58404 31.7706 8.53764L25.2851 5.83537L19.543 3.44282C18.8749 3.16442 18.1232 3.16442 17.455 3.44282L5.22744 8.53764C5.11607 8.58404 5.11607 8.7418 5.22744 8.7882L11.7129 11.4905L18.499 14.318Z",
    fill: "#2D3D95"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_32_2850",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.499 30.152V14.3177L31.8834 8.7409C31.9728 8.70365 32.0713 8.76933 32.0713 8.86618V23.5921C32.0713 24.14 31.7418 24.6342 31.2361 24.8449L18.499 30.152Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.499 30.152V14.3177L31.8834 8.7409C31.9728 8.70365 32.0713 8.76933 32.0713 8.86618V23.5921C32.0713 24.14 31.7418 24.6342 31.2361 24.8449L18.499 30.152Z",
    fill: "url(#paint0_linear_32_2850)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.499 14.3177L18.3685 14.0045C18.2421 14.0572 18.1597 14.1807 18.1597 14.3177H18.499ZM18.499 30.152H18.1597C18.1597 30.2654 18.2164 30.3714 18.3108 30.4343C18.4052 30.4972 18.5248 30.5088 18.6295 30.4652L18.499 30.152ZM31.2361 24.8449L31.3666 25.1581L31.2361 24.8449ZM31.8834 8.7409L32.0139 9.0541V9.0541L31.8834 8.7409ZM18.1597 14.3177V30.152H18.8383V14.3177H18.1597ZM18.6295 30.4652L31.3666 25.1581L31.1056 24.5317L18.3685 29.8388L18.6295 30.4652ZM32.4106 23.5921V8.86618H31.732V23.5921H32.4106ZM31.7529 8.42769L18.3685 14.0045L18.6295 14.6309L32.0139 9.0541L31.7529 8.42769ZM32.4106 8.86618C32.4106 8.52721 32.0657 8.29732 31.7529 8.42769L32.0139 9.0541C31.8798 9.10998 31.732 9.01145 31.732 8.86618H32.4106ZM31.3666 25.1581C31.9988 24.8947 32.4106 24.277 32.4106 23.5921H31.732C31.732 24.003 31.4849 24.3736 31.1056 24.5317L31.3666 25.1581Z",
    fill: "url(#paint1_linear_32_2850)",
    fillOpacity: 0.7,
    mask: "url(#path-2-inside-1_32_2850)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_32_2850",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.92676 8.86618V23.5921C4.92676 24.14 5.25621 24.6342 5.76197 24.8449L18.499 30.152V14.3177L5.11468 8.7409C5.02528 8.70365 4.92676 8.76933 4.92676 8.86618Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.92676 8.86618V23.5921C4.92676 24.14 5.25621 24.6342 5.76197 24.8449L18.499 30.152V14.3177L5.11468 8.7409C5.02528 8.70365 4.92676 8.76933 4.92676 8.86618Z",
    fill: "url(#paint2_linear_32_2850)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.499 14.3177H18.8383C18.8383 14.1807 18.756 14.0572 18.6295 14.0045L18.499 14.3177ZM18.499 30.152L18.3685 30.4652C18.4732 30.5088 18.5928 30.4972 18.6872 30.4343C18.7816 30.3714 18.8383 30.2654 18.8383 30.152H18.499ZM5.76197 24.8449L5.63147 25.1581H5.63147L5.76197 24.8449ZM5.11468 8.7409L4.98418 9.0541H4.98418L5.11468 8.7409ZM5.26606 23.5921V8.86618H4.58745V23.5921H5.26606ZM18.1597 14.3177V30.152H18.8383V14.3177H18.1597ZM18.6295 29.8388L5.89248 24.5317L5.63147 25.1581L18.3685 30.4652L18.6295 29.8388ZM4.98418 9.0541L18.3685 14.6309L18.6295 14.0045L5.24518 8.42769L4.98418 9.0541ZM5.26606 8.86618C5.26606 9.01145 5.11828 9.10998 4.98418 9.0541L5.24518 8.42769C4.93229 8.29732 4.58745 8.52721 4.58745 8.86618H5.26606ZM4.58745 23.5921C4.58745 24.277 4.99926 24.8947 5.63147 25.1581L5.89248 24.5317C5.51315 24.3736 5.26606 24.003 5.26606 23.5921H4.58745Z",
    fill: "url(#paint3_linear_32_2850)",
    fillOpacity: 0.7,
    mask: "url(#path-4-inside-2_32_2850)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_32_2850",
    x: 14.499,
    y: 4.73047,
    width: 21.5723,
    height: 29.4214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_32_2850"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_32_2850",
    result: "effect2_dropShadow_32_2850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_32_2850",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_32_2850"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bdi_32_2850",
    x: 0.926758,
    y: 4.73047,
    width: 21.5723,
    height: 29.4214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_32_2850"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_32_2850",
    result: "effect2_dropShadow_32_2850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_32_2850",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_32_2850"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_2850",
    x1: 14.088,
    y1: 0.0668354,
    x2: 48.3108,
    y2: 19.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344EA6",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#587EFF",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#829EFF",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32_2850",
    x1: 18.8383,
    y1: 11.886,
    x2: 34.7701,
    y2: 20.5107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32_2850",
    x1: 0.515776,
    y1: 0.0668354,
    x2: 34.7385,
    y2: 19.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344EA6",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#587EFF",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#829EFF",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32_2850",
    x1: 5.26606,
    y1: 11.886,
    x2: 21.1978,
    y2: 20.5107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.0155c41d67f2854d568f9c172862a4fd.svg";
export { ForwardRef as ReactComponent };